import { render } from "./FocusBox.vue?vue&type=template&id=0145f1c3&ts=true"
import script from "./FocusBox.vue?vue&type=script&lang=ts"
export * from "./FocusBox.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__